function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import DateRangePanel from './Panel/DateRangePanel';
import SingleSelectPanel from './Panel/SingleSelectPanel';
import DatepickerTrigger from './Trigger';
import { DatepickerContext } from '../context';
function Datepicker(props) {
  const {
    trigger,
    triggerLabel,
    primaryAction,
    arrowClassName,
    onTriggerSelect,
    triggerClassName,
    secondaryAction,
    triggerStyles,
    className
  } = props;
  const {
    isOpen,
    handleOnClose,
    isRangeDatePicker,
    handleResetClick,
    setDisableConfirmButton
  } = useContext(DatepickerContext);
  const datePickerContainerClass = classNames({
    'sib-datepicker-container': true,
    'sib-datepicker-container__new': true,
    'is-open': isOpen,
    [className]: !!className
  });
  const clearAction = {
    ...secondaryAction,
    onClick: e => {
      handleResetClick();
      secondaryAction.onClick(e);
    }
  };
  const confirmAction = {
    ...primaryAction,
    onClick: e => {
      handleOnClose(e);
      setDisableConfirmButton(true);
      primaryAction.onClick(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: datePickerContainerClass
  }, trigger && /*#__PURE__*/React.createElement(DatepickerTrigger, {
    triggerLabel: triggerLabel,
    triggerClassName: triggerClassName,
    arrowClassName: arrowClassName,
    onTriggerSelect: onTriggerSelect,
    triggerStyles: triggerStyles
  }), isRangeDatePicker ? /*#__PURE__*/React.createElement(DateRangePanel, _extends({}, props, {
    clearAction: clearAction,
    confirmAction: confirmAction
  })) : /*#__PURE__*/React.createElement(SingleSelectPanel, _extends({}, props, {
    clearAction: clearAction,
    confirmAction: confirmAction
  })));
}
Datepicker.propTypes = {
  trigger: PropTypes.bool,
  triggerLabel: PropTypes.string,
  arrowClassName: PropTypes.string,
  onTriggerSelect: PropTypes.func,
  triggerClassName: PropTypes.string,
  triggerStyles: PropTypes.object,
  className: PropTypes.string,
  secondaryAction: PropTypes.shape({
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'destructive']),
    label: PropTypes.string,
    onClick: PropTypes.func,
    iconAlone: PropTypes.bool,
    icon: PropTypes.node,
    ellipsis: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.bool,
    tooltipValue: PropTypes.object,
    dropdownOpen: PropTypes.bool,
    showArrowIcon: PropTypes.bool,
    className: PropTypes.string
  }),
  primaryAction: PropTypes.shape({
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'destructive']),
    label: PropTypes.string,
    onClick: PropTypes.func,
    iconAlone: PropTypes.bool,
    icon: PropTypes.node,
    ellipsis: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.bool,
    tooltipValue: PropTypes.object,
    dropdownOpen: PropTypes.bool,
    showArrowIcon: PropTypes.bool,
    className: PropTypes.string,
    handleResetClick: PropTypes.func
  })
};
Datepicker.defaultProps = {
  trigger: true,
  triggerLabel: '',
  arrowClassName: '',
  onTriggerSelect: () => {},
  triggerClassName: '',
  triggerStyles: {},
  primaryAction: {
    label: 'Confirm',
    variant: 'primary',
    onClick: () => {},
    disabled: false
  },
  className: '',
  secondaryAction: {
    label: 'Clear',
    variant: 'tertiary',
    onClick: () => {},
    disabled: false
  }
};
export default Datepicker;